import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, useQueryParam } from 'use-query-params';

import { queryKeys } from '../constants';

export function useDeleteWidget() {
  const qc = useQueryClient();
  const [dashboardId] = useQueryParam('dashboardId', NumberParam);

  return useMutation({
    mutationFn: async (id: number) => {
      const { data } = await $api.delete(`/v1/dashboard/widget/${id}`);

      return data;
    },
    onSuccess: async (res, id) => {
      showMessage(res.message, true);

      qc.setQueryData(
        [queryKeys.DASHBOARD_WIDGETS, dashboardId],
        // @ts-expect-error
        ({ widgets }: { widgets: dashboardV2Models.WidgetModel[] }) => ({
          widgets: widgets?.filter(item => item?.id !== id)
        })
      );
    },
    onError: baseErrorHandler
  });
}
